// Responsive image source builder.
// - Unsplash URLs: use the `w` query param for on-the-fly resizing.
// - Uploaded WebP (served from /uploads/): derive the auto-generated
//   `_thumb` variant by name convention (no DB/model changes needed).
// - Everything else (local assets, other externals): passthrough.

export function imageSources(rawUrl) {
  const url = rawUrl || "";

  if (/images\.unsplash\.com/i.test(url)) {
    const withW = (w) => {
      try {
        const u = new URL(url);
        u.searchParams.set("w", String(w));
        u.searchParams.set("q", "75");
        u.searchParams.set("auto", "format");
        return u.toString();
      } catch {
        return url;
      }
    };
    return { thumb: withW(600), medium: withW(1000), large: withW(1600) };
  }

  if (/\/uploads\//i.test(url) && /\.webp(\?|$)/i.test(url)) {
    const thumb = url.replace(/(\.webp)(\?|$)/i, "_thumb$1$2");
    return { thumb, medium: url, large: url };
  }

  return { thumb: url, medium: url, large: url };
}

// Tiny blurred placeholder (LQIP). Returns null when no low-res variant exists.
export function lqipSource(rawUrl) {
  const url = rawUrl || "";

  if (/images\.unsplash\.com/i.test(url)) {
    try {
      const u = new URL(url);
      u.searchParams.set("w", "32");
      u.searchParams.set("q", "30");
      u.searchParams.set("blur", "120");
      u.searchParams.set("auto", "format");
      return u.toString();
    } catch {
      return null;
    }
  }

  if (/\/uploads\//i.test(url) && /\.webp(\?|$)/i.test(url)) {
    return url.replace(/(\.webp)(\?|$)/i, "_lqip$1$2");
  }

  return null;
}
